function assertCents(value, field, allowZero = true) {
    if (!Number.isSafeInteger(value) || value < (allowZero ? 0 : 1)) {
        throw new Error(`${field} must be a ${allowZero ? 'non-negative' : 'positive'} safe integer.`);
    }
}
export function derivePaymentState(priceCents, amountPaidCents, amountRefundedCents) {
    assertCents(priceCents, 'priceCents');
    assertCents(amountPaidCents, 'amountPaidCents');
    assertCents(amountRefundedCents, 'amountRefundedCents');
    if (amountRefundedCents > amountPaidCents) {
        throw new Error('Refunds cannot exceed payments.');
    }
    if (amountRefundedCents === amountPaidCents && amountPaidCents > 0)
        return 'refunded';
    if (amountRefundedCents > 0)
        return 'partially_refunded';
    if (amountPaidCents === 0)
        return 'pending';
    if (amountPaidCents < priceCents)
        return 'partially_paid';
    return 'paid';
}
export function calculateBalance(priceCents, entries) {
    assertCents(priceCents, 'priceCents');
    let amountPaidCents = 0;
    let amountRefundedCents = 0;
    for (const entry of entries) {
        assertCents(entry.amountCents, 'amountCents', false);
        if (entry.entryType === 'payment')
            amountPaidCents += entry.amountCents;
        else
            amountRefundedCents += entry.amountCents;
        if (amountRefundedCents > amountPaidCents) {
            throw new Error('Refunds cannot exceed cumulative payments.');
        }
    }
    const netReceivedCents = amountPaidCents - amountRefundedCents;
    return {
        priceCents,
        amountPaidCents,
        amountRefundedCents,
        netReceivedCents,
        balanceCents: Math.max(priceCents - netReceivedCents, 0),
        paymentState: derivePaymentState(priceCents, amountPaidCents, amountRefundedCents),
    };
}
export function forecastContributionCents(lifecycleStatus, priceSnapshotCents) {
    assertCents(priceSnapshotCents, 'priceSnapshotCents');
    return ['cancelled', 'no_show', 'rescheduled'].includes(lifecycleStatus) ? 0 : priceSnapshotCents;
}
export function deriveAppointmentPrice(option) {
    assertCents(option.defaultPriceCents, 'defaultPriceCents');
    if (option.socialCareEnabled && option.overrideCents != null) {
        assertCents(option.overrideCents, 'overrideCents');
        return { priceCents: option.overrideCents, source: 'social_override' };
    }
    return { priceCents: option.defaultPriceCents, source: 'appointment_type_default' };
}
export function formatMoney(cents) {
    assertCents(Math.abs(cents), 'cents');
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cents / 100);
}
export function summarizeFinancials(appointments) {
    return appointments.reduce((totals, appointment) => {
        const balance = calculateBalance(appointment.priceSnapshotCents, appointment.ledgerEntries);
        totals.forecastCents += forecastContributionCents(appointment.lifecycleStatus, appointment.priceSnapshotCents);
        totals.grossPaymentsCents += balance.amountPaidCents;
        totals.refundsCents += balance.amountRefundedCents;
        totals.netReceiptsCents += balance.netReceivedCents;
        totals.outstandingBalanceCents += balance.balanceCents;
        return totals;
    }, {
        forecastCents: 0,
        grossPaymentsCents: 0,
        refundsCents: 0,
        netReceiptsCents: 0,
        outstandingBalanceCents: 0,
    });
}
//# sourceMappingURL=money.js.map